/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_PlayingInputs */

const en_audio_playing = /** @type {(inputs: Audio_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playing`)
};

const es_audio_playing = /** @type {(inputs: Audio_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproduciendo`)
};

/**
* | output |
* | --- |
* | "Playing" |
*
* @param {Audio_PlayingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audio_playing = /** @type {((inputs?: Audio_PlayingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_PlayingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_audio_playing(inputs)
	return en_audio_playing(inputs)
});